// extracted by mini-css-extract-plugin
export default {"filter-column-height":"SummaryFilterBox_filter-column-height__C7AjA","ipad-pro-filterbox":"SummaryFilterBox_ipad-pro-filterbox__D3T2x"};